import resetSliderValues from './resetSliderValues';
import ChangePageModifier from './changePageModifier';
import LoadMoreApptus from './loadMoreApptus';

export default function ActivateApptusTab(id, isLoadMore) {
  var $currentTab = $("#" + id);

  $('#search-input').val('');

  var $tabWrapper = $('.tab-frame');
  if (id === 'SO_PLO2') {
    $currentTab = $('#SO_PRICE');
    $('.discount-link').toggleClass('active');
    if (!$('.discount-link').hasClass('active')) {
      id = 'SO_PRICE'
    }
  }
  else {
    $('.discount-link').removeClass('active');
  }
  $('.tab-panel li').removeClass('active');
  $currentTab.addClass('active');
  $tabWrapper.removeClass('func-range-slider func-alphabet-search func-voice filter-active');
  var dataAttrViewMode = $currentTab.find("span").attr("data-btn");
  if (dataAttrViewMode) {
    $tabWrapper.addClass(dataAttrViewMode + ' filter-active');
  }
  resetSliderValues();
  if (isLoadMore) {
    $(document).ready(function () {
      LoadMoreApptus(1, id);
  })
    ChangePageModifier(1);
  }
  
  return false;
}